/**
 * Created by Alex Aguilar on 5/25/2016.
 */
(function(){
    'use strict'

    angular.module('completeAir')
        .factory('uploadService', ['Upload', 'messageService', uploadService]);

    function uploadService(Upload, messageService){
        return {
            uploadImage: uploadImage
        };

        function uploadImage(file, category, dirUpload, cb){

            Upload.upload({
                url: '/uploads?dirUpload=' + dirUpload + '&category=' + category,
                method: 'POST',
                data:{
                    file:file
                }
            }).then(function (res) {
                if(res.data.error_code === 0){
                    cb(res.data.file);
                } else {
                    messageService.uploadImageError();
                }

            }, function (resp) {
                messageService.uploadImageError();
            });
        }
    }
})();
